import { Price } from '../../../../../../types';
import { IListPrices, IPriceListPanelProps, ICommonListProps } from '../types';

export function getListLimits(prices: IListPrices) {
  const mainListLimit =
    prices.mainList.length <= 35 ? prices.mainList.length : 35;
  const unfeaturedListLimit =
    prices.unfeaturedList && prices.unfeaturedList.length <= 15
      ? prices.unfeaturedList.length
      : 15;
  return { mainListLimit, unfeaturedListLimit };
}

export function getListPrices(
  sortedPrices: Price[] | null | undefined,
  splitList: boolean
): IListPrices {
  if (!splitList) {
    return { mainList: sortedPrices || [], unfeaturedList: null };
  }

  return {
    mainList: sortedPrices?.filter(f => f.store?.featured === true) || [],
    unfeaturedList:
      sortedPrices?.filter(f => f.store?.featured === false) || [],
  };
}

export const getCommonListProps = (
  props: IPriceListPanelProps
): ICommonListProps => {
  return {
    productId: props.productId,
    productName: props.productName,
    media: props.media,
    brand: props.brand,
    campaign: props.campaign,
    junkFilter: props.junkFilter,
    dispatchProductPriceClick: props.dispatchProductPriceClick,
    dispatchProductClickOutBounce: props.dispatchProductClickOutBounce,
    currentSort: props.currentSort,
    currentGrouping: props.currentGrouping,
    adOffset: props.adOffset,
  };
};
